import "@lottiefiles/lottie-player";
import LottieInteractivity from '@lottiefiles/lottie-interactivity';
import {create} from "@lottiefiles/lottie-interactivity";
const initLottiefilesQuickNavi = () => {
  let lottie1, lottie2 = null;
  const quicknaviLottie1 = document.querySelector("#quicknaviLottie1");
  const quicknaviLottie2 = document.querySelector("#quicknaviLottie2");
  if(quicknaviLottie1 && quicknaviLottie2){
    const screatLottie = () =>{

      create({
        player: quicknaviLottie1,
        mode:"cursor",
        actions: [
          {
            type: "hover",
            forceFlag: false
          }
        ]
      });
      create({
        player: quicknaviLottie2,
        mode:"cursor",
        actions: [
          {
            type: "hover",
            forceFlag: false
          }
        ]
      });

    }
    screatLottie();
  }
};
export default initLottiefilesQuickNavi;
